import PropTypes from 'prop-types'

import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import EntitySelector from '@components/EntitySelector'

import { generateUrls } from '@hooks/useBrand'

const BrandGroupDetails = (props) => {
  const { brandGroupFormPayload } = props || {}
  const {
    entityState: {
      brand_id,
      title,
    },
    errors,
    handlers,
    setEntityState,
  } = brandGroupFormPayload

  const { editBrandUrl } = generateUrls({ id: brand_id })

  return (
    <DashboardModule title="Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.title} label="* Group Title">
            <input
              name="title"
              value={title}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <EntitySelector
            callbacks={{
              selectItem: brand => setEntityState({ brand_id: brand ? brand.id : null }),
            }}
            entityKey="brands"
            goToHref={`${editBrandUrl}?redirect=${generateRedirectUrl()}`}
            label="* Brand"
            marginTop={['large', 0]}
            selectedItemId={brand_id}
          />
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

BrandGroupDetails.propTypes = {
  brandGroupFormPayload: PropTypes.shape({
    entityState: PropTypes.shape({
      brand_id: PropTypes.number,
      title: PropTypes.string,
    }),
    errors: PropTypes.object,
    handlers: PropTypes.object.isRequired,
  }).isRequired,
}

export default BrandGroupDetails
